import { ProductInput } from '@/models/Import'
import { SimplifiedProduct } from '@/models/Product'
import { useDefaultStore } from '@/store'
import { computed, Ref } from 'vue'
import { useSelectedProperties } from './useSelectedProperties'

export const useProductFunctions = (product: Ref<SimplifiedProduct | ProductInput | undefined>) => {
  const store = useDefaultStore()
  const { initProperties, getPropertyByName, properties } = useSelectedProperties('products')

  const productName = computed(() => {
    if (!properties.value) {
      initProperties()
      return
    }

    if (product.value) {
      if ('name' in product.value && product.value.name) {
        return {
          property: getPropertyByName('name'),
          language: store.dataCulture?.language,
        }
      } else {
        return {
          property: getPropertyByName('main name'),
          language: product.value?.mainLanguage,
        }
      }
    }

    return undefined
  })

  const productAvailabilityCss = computed(() =>
    product.value?.availability && 'css' in product.value.availability ? `availability-${product.value?.availability?.css}` : '',
  )

  return {
    productName,
    productAvailabilityCss,
  }
}
